export class Proveedor {
    idprovee?:string;
    razonsocial?:string;
    direccion?:string;
    ruc?:string;
    telefono?:string;
    contacto?:string;
    nota?:string;
    cuenta?:string;
    email?:string;
    actividad?:string;
    distrito?:string;
    dtmodificacion?:string;
    tip_iden?:string;
    codubigeo?:string;
    constructor(){}
}
